export default "__VITE_ASSET__D055Ctuj__"